import React from 'react'
import { toFixedThree } from '../../utility/helper';
import { useNavigate } from 'react-router-dom';

interface CustomerData {
    userId: string;
    customerName: string;
    count: number;
    sales: number;
}

const TopCustomers: React.FC<{ customers: CustomerData[], heading: string, type: string }> = ({ customers = [], heading, type }) => {
    let sortedCustomers = [];
    if (type === 'sales') {
        sortedCustomers = [...customers].sort((a, b) => b.sales - a.sales);
    } else {
        sortedCustomers = [...customers].sort((a, b) => b.count - a.count);
    }
    const navigate = useNavigate();
    return (
        <div className="app-card app-card-orders-table shadow-sm mb-4">
            <div className="p-4">
                <h5 className="mb-4 card-title">{heading}</h5>
                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Customer</th>
                                <th>Orders</th>
                                <th>Total Spent</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sortedCustomers.map((data, index) => (
                                <tr key={index}>
                                    <td>{data.customerName || "Unknown"}</td>
                                    <td>{data.count}</td>
                                    <td>{toFixedThree(data.sales)}</td>
                                    <td>
                                        <button className="btn btn-sm btn-primary" onClick={() => navigate("/user-details/" + data.userId)} >
                                            <i className="bi bi-eye"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default TopCustomers;
